import React, { useState, useEffect } from 'react';
import axios from 'axios';
import * as d3 from 'd3';
const Dashboard = () => {

    const [totalInvoices, setTotalInvoices] = useState(0);
    const [totalSales, setTotalSales] = useState(0);
    const [totalProducts, setTotalProducts] = useState(0);

    useEffect(() => {
        axios.get('https://653cb488d5d6790f5ec82dfd.mockapi.io/api/v1/sales')
            .then((res) => {
                const sales = res.data;
                const total = sales.reduce((accumulator, current) => {
                    return accumulator + current.billamount;
                }, 0)
                setTotalSales(total);

                const invoiceQuantity = sales.length;
                setTotalInvoices(invoiceQuantity);
            })

        axios.get('https://653cb488d5d6790f5ec82dfd.mockapi.io/api/v1/products')
            .then((res) => {
                const productQuantity = res.data.length;
                setTotalProducts(productQuantity);
            })

    }, []);


    return (
        <div>
            <main id="main" class="main">

                <div class="pagetitle">
                    <h1>Dashboard</h1>
                    {/* BREADCRUMB */}
                    {/* <nav>
                        <ol class="breadcrumb">
                            <li class="breadcrumb-item"><a href="index.html">Home</a></li>
                            <li class="breadcrumb-item active">Dashboard</li>
                        </ol>
                    </nav> */}
                </div>
                {/* <!-- End Page Title --> */}

                <section class="section dashboard">
                    <div class="row">

                        {/* <!-- Left side columns --> */}
                        <div class="col-lg-8">
                            <div class="row">
                                {/* <!-- Sales Card --> */}
                                <div class="col-xxl-4 col-md-6">
                                    <div class="card info-card sales-card">



                                        <div class="card-body">
                                            <h5 class="card-title">Invoices <span>| total</span></h5>

                                            <div class="d-flex align-items-center">
                                                <div class="card-icon rounded-circle d-flex align-items-center justify-content-center">
                                                    <i class="bi bi-receipt"></i>
                                                </div>
                                                <div class="ps-3">
                                                    <h6>{totalInvoices}</h6>
                                                    {/* <span class="text-success small pt-1 fw-bold">12%</span> <span class="text-muted small pt-2 ps-1">increase</span> */}

                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                {/* <!-- End Sales Card --> */}

                                {/* <!-- Revenue Card --> */}
                                <div class="col-xxl-4 col-md-6 w-200px">
                                    <div class="card info-card revenue-card">



                                        <div class="card-body">
                                            <h5 class="card-title">Revenue <span>| total</span></h5>

                                            <div class="d-flex align-items-center">
                                                <div class="card-icon rounded-circle d-flex align-items-center justify-content-center">
                                                    <i class="bi bi-currency-rupee"></i>
                                                </div>
                                                <div class="ps-3">
                                                    <h6>Rs {totalSales}</h6>
                                                    {/* <span class="text-success small pt-1 fw-bold">8%</span> <span class="text-muted small pt-2 ps-1">increase</span> */}

                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                </div>
                                {/* <!-- End Revenue Card --> */}

                                {/* <!-- Customers Card --> */}
                                <div class="col-xxl-4 col-xl-12">

                                    <div class="card info-card customers-card">

                                        <div class="card-body">
                                            <h5 class="card-title">Products <span>| total</span></h5>

                                            <div class="d-flex align-items-center">
                                                <div class="card-icon rounded-circle d-flex align-items-center justify-content-center">
                                                    <i class="bi bi-box-seam"></i>
                                                </div>
                                                <div class="ps-3">
                                                    <h6>{totalProducts}</h6>
                                                    {/* <span class="text-danger small pt-1 fw-bold">12%</span> <span class="text-muted small pt-2 ps-1">decrease</span> */}

                                                </div>
                                            </div>

                                        </div>
                                    </div>

                                </div>
                                <div class="col-12">
                                    <div class="card">


                                        <div class="card-body">
                                            <h5 class="card-title">Reports <span>/Today</span></h5>

                                            {/* <!-- Line Chart --> */}
                                            <div id="reportsChart"></div>

                                            {/* <script>
                    document.addEventListener("DOMContentLoaded", () => {
                      new ApexCharts(document.querySelector("#reportsChart"), {
                        series: [{
                          name: 'Sales',
                          data: [31, 40, 28, 51, 42, 82, 56],
                        }, {
                          name: 'Revenue',
                          data: [11, 32, 45, 32, 34, 52, 41]
                        }, {
                          name: 'Customers',
                          data: [15, 11, 32, 18, 9, 24, 11]
                        }],
                        chart: {
                          height: 350,
                          type: 'area',
                          toolbar: {
                            show: false
                          },
                        },
                        markers: {
                          size: 4
                        },
                        colors: ['#4154f1', '#2eca6a', '#ff771d'],
                        fill: {
                          type: "gradient",
                          gradient: {
                            shadeIntensity: 1,
                            opacityFrom: 0.3,
                            opacityTo: 0.4,
                            stops: [0, 90, 100]
                          }
                        },
                        dataLabels: {
                          enabled: false
                        },
                        stroke: {
                          curve: 'smooth',
                          width: 2
                        },
                        xaxis: {
                          type: 'datetime',
                          categories: ["2018-09-19T00:00:00.000Z", "2018-09-19T01:30:00.000Z", "2018-09-19T02:30:00.000Z", "2018-09-19T03:30:00.000Z", "2018-09-19T04:30:00.000Z", "2018-09-19T05:30:00.000Z", "2018-09-19T06:30:00.000Z"]
                        },
                        tooltip: {
                          x: {
                            format: 'dd/MM/yy HH:mm'
                          },
                        }
                      }).render();
                    });
                  </script> */}
                                            {/* <!-- End Line Chart --> */}

                                        </div>

                                    </div>
                                </div>
                                {/* <!-- End Reports --> */}
                            </div>
                        </div>

                    </div>
                </section>

            </main>
            {/* <!-- End #main --> */}
        </div>
    )
}

export default Dashboard